module.exports = __webpack_public_path__ + "img/cpjc.5e8489ca.png";